module.exports = __webpack_public_path__ + "static/media/S2N2-5.78766bd6.svg";